import { ChainId } from '@amply-app/sdk';

export const getChainId = (): ChainId => {
  if (process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'uat') {
    return ChainId.CRONOS_ZKEVM_MAINNET;
  }

  return ChainId.CRONOS_ZKEVM_TESTNET;
};
